































































































































































import { cloneDeep } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import ModelSetter from '../../../Mixins/ModelSetter'
import { errorNotificationWrapper } from '../../../logic/helpers/NotificationService'
import { timezoneList } from '../../../logic/timizone-list'
import { SelectOption } from "../../../logic/types";
import { ChannelInfo } from "../../../shared/types/Channel";
import { PlaceholdersOnes, PlaceholdersStack } from "../../Editor/components/Toolbar/types";
import { SuccessGetUser } from '../../Flow/logic/types/type'
import { UseFields } from '../../Pi'
import MultiMessageEditorWithMediaInput from '../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import { SelectOptionData } from '../../Pi/types'
import Picker from '../../Picker/Picker.vue'
import { PickerFormat } from '../../Picker/types'
import { Distribution, FullDistribution } from '../Distribution'
import DistributionConditions from './DistributionConditions/DistributionConditions.vue'
import { DistributionEditorAction, MessageEditorProps } from './types'

@Component({
  data() {
    return {
      DistributionEditorAction,
      PickerFormat,
      isMobile,
      timezoneList,
    }
  },
  components: {
    DistributionConditions,
    Picker,
    MultiMessageEditorWithMediaInput
  }
})
export default class DistributionEditor extends Mixins(UseFields, ModelSetter) {
  @Prop() messageEditorProps!: MessageEditorProps

  @Prop() labelsOptions!: Array<SelectOptionData>

  @Prop() utmSources!: Array<{ id: number, value: string }>

  @Prop() getUsersInfo!: (users: Array<string | number>) => Promise<Array<Omit<SuccessGetUser, 'status'>>>

  @Prop() getChannelsInfo!: (targets: Array<string | number>) => Promise<Array<ChannelInfo>>

  @Prop() targets!: Array<SelectOption>

  @Prop() distribution!: Distribution | FullDistribution

  @Prop() saveDistribution!: (distribution: Distribution | FullDistribution) => void

  @Prop() goToList!: () => void

  @Prop() preCheckDistribution!: (conditions: FullDistribution['conditions']) => Promise<number>

  @Prop() defaultTimezone!: string

  @Prop() placeholders!: PlaceholdersOnes | PlaceholdersStack

  preCheckCount = 0

  isPreCheckLoading = false

  distributionModel: Distribution | FullDistribution | null = null

  timezoneModalOpen = false

  currentTimezone = ''

  get action(): DistributionEditorAction {
    return this.$route.params.actionType as DistributionEditorAction
  }

  get disabled():boolean {
    return this.action === DistributionEditorAction.watch
  }

  get isRunNowButtonDisabled(): boolean {
    if (this.distributionModel) {
      const templates = this.distributionModel.content.templates

      return !templates.length
        || !templates[0].text.length
        || templates[0].text === '\n'
    }

    return true
  }

  get isSaveButtonDisabled(): boolean {
    if (this.distributionModel) {
      const templates = this.distributionModel.content.templates

      const templatesIsValid = !!templates.length
        || !!templates[0].text.length
        || templates[0].text !== '\n'

      return !(this.distributionModel.time && templatesIsValid)
    }

    return true
  }

  conditionsChange(conditions: FullDistribution['conditions']) {
    if (this.distributionModel) {
      this.distributionModel.conditions = conditions

      try {
        this.distributionModel.validateConditions(this.$i18n)

        this.isPreCheckLoading = true

        this.preCheckDistribution(conditions)
          .then((count) => this.preCheckCount = count)
          .finally(() => this.isPreCheckLoading = false)
      } catch (e: unknown) {
        errorNotificationWrapper(this.$t('error').toString(), (e as Error).message)
      }
    }
  }

  prepareForSave() {
    try {
      this.distributionModel?.validateConditions(this.$i18n)

      this.saveDistribution(this.distributionModel!)

    } catch (e: unknown) {
      errorNotificationWrapper(this.$t('error').toString(), (e as Error).message)
    }
  }

  handleTimezoneOkClick(): void {
    if (this.distributionModel) {
      this.distributionModel.timezone = this.currentTimezone
      this.timezoneModalOpen = false
    }
  }

  handleCancel() {
    if (this.distributionModel && this.distributionModel.timezone) {
      this.currentTimezone = this.distributionModel.timezone
    }
  }

  startNow(): void {
    if (this.distributionModel) {
      const modelCopy = cloneDeep(this.distributionModel)
      modelCopy.resetTime()

      this.saveDistribution(modelCopy)
    }
  }

  created(): void {
    this.distributionModel = cloneDeep(this.distribution)

    this.currentTimezone = this.distributionModel.timezone = this.defaultTimezone
  }
}
